<template>
  <div class="select-card" :class="{ isSingle: isSingle, notBuy: notBuy }">
    <h1 class="name ellipsis">{{ courseInfo.productName }}</h1>
    <div class="courseSelect" v-show="!isSingle" v-for="(item, n) in productSpecJson" :key="n">
      <h3 class="subheading" v-text="item.specName"></h3>
      <div class="courseSelectTabs">
        <p
          class="tabItem ellipsis"
          v-for="(list, index) in item.options"
          :key="index"
          @click="chooseSkuInfo(list.name, n, $event, index)"
          :class="{ noneActive: !list.isShow, tabSelected: subIndex[n] == index }"
        >
          <span v-text="list.name"></span>
          <img v-if="subIndex[n] == index" :src="checkIcon" alt="checkIcon" />
        </p>
      </div>
    </div>
    <img class="single-icon" :src="checkIcon" alt="checkIcon" />
  </div>
</template>

<script>
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';

export default {
  components: {},
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      checkIcon,
      productSpecJson: [], // 展示在页面的sku规格
      selectArr: [], // 选中的值
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      subIndex: [], // 是否选中
      selectSku: {}, // 选中的sku信息
      someOne: null, // 可用的一条sku，用于展示默认选中的sku
      isSingle: false, // 是否为单品
      notBuy: true, // 是否购买 下架 过期 售罄
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.modifySkuRespVOList();
  },
  methods: {
    // 选中sku属性
    chooseSkuInfo(item, n, event, index) {
      if (this.selectArr[n] !== item) {
        [this.selectArr[n], this.subIndex[n]] = [item, index];
      } else {
        this.selectSku = {};
        [this.selectArr[n], this.subIndex[n]] = ['', '-1'];
      }
      // this.findItem(item, n, index);
      if (n === 0) {
        const specJson = JSON.parse(this.selectSku.specJson);
        if (specJson.length > 1) {
          const arr = [item, specJson[1].value];
          const findRes = this.courseInfo.productSkuOptions.find((ele) => {
            const defautName = [];
            if ((ele.isSetStock === 1 && ele.availableStock > 0) || ele.isSetStock === 0) {
              JSON.parse(ele.specJson).forEach((child) => {
                defautName.push(child.value);
              });
            }
            return defautName.toString() === arr.toString();
          });
          if (!findRes) {
            this.findItem(item, n, index);
          }
        }
      }
      this.checkItem();
    },
    findItem(item) {
      let res = null;
      try {
        this.courseInfo.productSkuOptions.forEach((ele) => {
          const specJson = JSON.parse(ele.specJson);
          specJson.forEach((list) => {
            if (
              list.value === item
              && ((ele.isSetStock === 1 && ele.availableStock > 0) || ele.isSetStock === 0)
            ) {
              res = ele;
              throw Error();
            }
          });
        });
      } catch (error) {
        //
      }
      this.setDefault([res]);
    },
    checkItem() {
      const self = this;
      const result = this.selectArr; // 定义数组储存被选中的值
      this.productSpecJson.forEach((element, i) => {
        const last = result[i];
        element.options.forEach((k) => {
          result[i] = k.name;
          // k.isShow = this.someOne ? this.isMay(result) : false; // isShow来判断是否可以选择
          Object.assign(k, { isShow: this.someOne ? this.isMay(result) : false });
          // if (
          //   i === 0
          //   && this.productSpecJson.length > 1
          //   && this.courseInfo?.productSkuOptions?.length > 1
          // ) {
          //   Object.assign(k, { isShow: true });
          // }
          if (i === 0) {
            const filterRes = this.courseInfo?.productSkuOptions.filter(
              (item) => !(item.isSetStock === 1 && item.availableStock === 0),
            );
            const flag = filterRes.find((item) => JSON.parse(item.specJson).find((child) => child.value === k.name));
            Object.assign(k, { isShow: !!flag });
          }
        });
        result[i] = last; // 还原，目的是记录点下去那个值
      });
      if (this.shopItemInfo[result]) {
        this.selectSku = this.shopItemInfo[result];
        this.sendParentSkuId(this.selectSku);
      }
      self.$forceUpdate(); // 重绘
    },
    // 能否被选中
    isMay(result) {
      // eslint-disable-next-line no-restricted-syntax
      for (const k in result) {
        if (result[k] === '') {
          return true;
        }
      }
      // 校验list中是否有此条sku
      if (result && !this.shopItemInfo[result]) {
        return false;
      }
      // 校验sku库存
      return !(
        this.shopItemInfo[result].isSetStock === 1 && this.shopItemInfo[result].availableStock === 0
      );
    },
    // 修改数据结构,将选中的值作为key，以方便和选中之后的值进行匹配
    modifySkuRespVOList() {
      const {
        productSkuOptions,
        productSpecJson,
        isBuy,
        isExpire,
        isOffline,
        isSoldOut,
      } = this.courseInfo;
      this.notBuy = isBuy || isExpire || isOffline || isSoldOut;
      if (!productSpecJson && !productSkuOptions) return;
      // if (!productSpecJson) {
      //   // 无sku
      //   this.$store.dispatch('saveProductSku', productSkuOptions[0]);
      //   return;
      // }

      productSkuOptions.forEach((item) => {
        this.isSingle = item.isDefault === 1;
        this.shopItemInfo[String(JSON.parse(item.specJson).map((child) => child.value))] = item;
      });
      JSON.parse(productSpecJson).forEach((item) => {
        Object.assign(item, { options: item.options.map((element) => ({ name: element })) });
        this.productSpecJson.push(item);
      });
      this.setDefault(productSkuOptions);
      this.checkItem();
    },
    // 默认一个可用的sku
    setDefault(productSkuOptions) {
      const defautIdx = [];
      const defautName = [];
      this.someOne = productSkuOptions.find(
        (item) => (item.isSetStock === 1 && item.availableStock > 0) || item.isSetStock === 0,
      );
      if (!this.someOne) return;
      this.productSpecJson.forEach((item) => {
        item.options.forEach((list, i) => {
          JSON.parse(this.someOne.specJson).forEach((child) => {
            if (list.name === child.value) {
              defautName.push(list.name);
              defautIdx.push(i);
            }
          });
        });
      });
      this.subIndex = defautIdx;
      this.selectArr = defautName;
    },
    // 将选中的sku保存到vuex 中
    sendParentSkuId(sku) {
      if (!sku.productSkuId) return;
      const course = JSON.parse(JSON.stringify(this.courseInfo));
      course.selectSkuInfo = sku;
      this.$emit('skuInfo', course);
    },
  },
};
</script>

<style lang="scss" scoped>
.select-card {
  padding: 32px 0;
  .single-icon {
    display: none;
  }
}
.notBuy.select-card.isSingle {
  background: #fafafa;
  border: 1px solid #e8e8e8;
  pointer-events: none;
  .name,
  h3,
  span {
    color: #c8c8c8;
  }
}
.notBuy.select-card {
  span {
    color: #c8c8c8;
  }
  p {
    background: #fafafa !important;
    border: 1px solid #e8e8e8 !important;
    pointer-events: none;
  }
  img {
    display: none !important;
  }
}
.isSingle.select-card {
  position: relative;
  // width: 678px;
  margin: 20px auto;
  padding: 10px 30px;
  background: #fff5ed;
  border: 2px solid #ff6c02;
  border-radius: 4px;
  // margin-bottom: 20px solid #f9f9f9;

  .single-icon {
    position: absolute;
    right: 0;
    bottom: 0;
    display: block;
    width: 30px;
    height: 30px;
  }
  .name{
    color: #FF6C02;
  }
}
.name {
  padding-bottom: 5px;
  color: #333;
  font-weight: 400;
  font-size: 28px;
  line-height: 44px;
}
.courseSelect {
  display: flex;
  width: 100%;
  // min-height: 130px;
  // margin: 22px 0;
  padding: 5px 0 0 0;
  background: #fff;

  .subheading {
    flex-shrink: 0;
    width: 115px;
    padding-top: 28px;
    color: #333;
    font-weight: 400;
    font-size: 28px;
  }
  .courseSelectTabs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // margin-left: 4px;

    p {
      position: relative;
      box-sizing: border-box;
      width: 164px;
      margin: 10px;
      padding: 12px;
      overflow: hidden;
      color: #787878;
      font-size: 22px;
      line-height: 30px;
      text-align: center;
      background: #fff;
      border: 2px solid #e8e8e8;
      border-radius: 4px;

      img {
        position: absolute;
        right: 0;
        bottom: 0;
        display: none;
        width: 30px;
        height: auto;
      }
    }

     p:nth-child(3n) {
      margin-right: 0;
    }

    .tabSelected {
      box-sizing: border-box;
      color: #ff6c02;
      background: #fff5ed;
      border: 2px solid #ff6c02;
      border-radius: 4px;
      pointer-events: none;
      img {
        display: block;
      }
    }

    .noneActive {
      color: #cfcfcf;
      background: #f5f5f5;
      border: 2px solid #f5f5f5;
      border-radius: 4px;
      pointer-events: none;
      img {
        display: none;
      }
    }
  }
}
</style>
